import React from "react"
import GenericModal from "@irati/ui/src/GenericModal"
import {Body, H3} from "@irati/ui/src/Typography"
import FormattedMessage, {injectIntl} from "@irati/utils/lang"
import {InjectIntlProps} from "@irati/utils/lang/injectIntl"
import Flex from "@irati/ui/src/Flex"
import Button from "@irati/ui/src/Button"
import mainTheme from "@irati/ui/src/global/theme"
interface Props extends InjectIntlProps {
  show: boolean
  onHide: () => void
  onConfirmButton: () => void
}
const AutomationDeactivateModal = (props: Props) => {
  const {show, onHide, onConfirmButton, formatMessage} = props
  return (
    <GenericModal show={show} small onHide={onHide} onExited={onHide} hideActions>
      <H3 textAlign="center" marginBottom={3}>
        <FormattedMessage id="admin.automation.title.popupDeactivate" />
      </H3>
      <Body small textAlign="center">
        <FormattedMessage id="admin.automation.msg.popupDeactivateMain" />
      </Body>
      <Body small textAlign="center" marginTop={2}>
        <FormattedMessage id="admin.automation.msg.popupDeactivateSub" />
      </Body>
      <Flex direction="column" gap={mainTheme.spacing.oneAndHalf} marginTop={3}>
        <Button onClick={onConfirmButton} full primary>
          <FormattedMessage id="admin.automation.btn.confirmDeactivation" />
        </Button>
        <Button onClick={onHide} full>
          <FormattedMessage id="platform.button.cancel" />
        </Button>
      </Flex>
    </GenericModal>
  )
}

export default injectIntl(AutomationDeactivateModal)
